import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.jpg';
const _withScopeId = n => (_pushScopeId("data-v-4c2879ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "广告合作邮箱", -1));
const _hoisted_3 = {
  class: "link"
};
const _hoisted_4 = {
  class: "down-app"
};
const _hoisted_5 = {
  class: "down-div"
};
const _hoisted_6 = {
  class: "left"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-img",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, [/*#__PURE__*/_createElementVNode("div", null, "海角免费版"), /*#__PURE__*/_createElementVNode("div", null, "下载app免费观看百万视频")], -1));
import { onMounted, ref } from "vue";
import { store } from "../utils/store";
import { useRoute } from 'vue-router';
import { judgeClient, isH5 } from '@/utils';
export default {
  __name: 'Footer',
  setup(__props) {
    const route = useRoute();
    const showDownload = ref(false);
    const openWebsite = () => {
      window.open(store.config.website);
    };
    const downloadApp = () => {
      const iosArr = store.config.ios_download_urls.split(',');
      const androidArr = store.config.android_download_urls.split(',');
      if (judgeClient() === 'IOS') {
        var url = iosArr[Math.floor(Math.random() * iosArr.length)];
        if (!url) {
          alert('获取下载配置失败，请联系管理员！');
          return;
        }
        window.open(url);
      }
      if (judgeClient() === 'Android') {
        var url = androidArr[Math.floor(Math.random() * androidArr.length)];
        if (!url) {
          alert('获取下载配置失败，请联系管理员！');
          return;
        }
        window.open(url);
      }
    };
    onMounted(() => {
      setTimeout(() => {
        console.log('android_download_urls', store.config.android_download_urls);
        //增加判断，接口返回有App下载链接时候，如果是h5,才展示底部的下载弹窗。
        if (store.config.android_download_urls != undefined && store.config.android_download_urls != "") {
          showDownload.value = isH5();
        }
      }, 1000);
    });
    return (_ctx, _cache) => {
      const _component_AdsPictures = _resolveComponent("AdsPictures");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", null, [_createElementVNode("a", _hoisted_3, "💖💖💖邮箱：" + _toDisplayString(_unref(store).config.telegram) + "💖💖💖 ", 1)]), _createElementVNode("p", null, [_createTextVNode("牢记本站域名："), _createElementVNode("span", {
        class: "link",
        onClick: _cache[0] || (_cache[0] = $event => openWebsite())
      }, _toDisplayString(_unref(store).config.website), 1)])]), _createVNode(_component_AdsPictures, {
        type: 14
      }), _withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_icon, {
        name: "cross",
        class: "popup-close-icon",
        onClick: _cache[1] || (_cache[1] = $event => showDownload.value = false)
      }), _hoisted_7, _hoisted_8]), _createElementVNode("div", null, [_createVNode(_component_van_button, {
        type: "primary",
        size: "small",
        onClick: downloadApp
      }, {
        default: _withCtx(() => [_createTextVNode("立即下载")]),
        _: 1
      })])])], 512), [[_vShow, showDownload.value]])], 64);
    };
  }
};